import { HttpService } from "@mancala/core"

export class HttpServiceImpl implements HttpService {
  public serverAdress: string;

  constructor(serverAdress: string) {
    this.serverAdress = serverAdress;
  }

  // With a token, the request is authenticated as that user.
  public async get(route: string, token?: string): Promise<Response> {
    const url = this.serverAdress + route;
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const response = await fetch(url, { method: 'GET', headers });
    return response;
  }
}
